import { render, staticRenderFns } from "./tabbar3.8.vue?vue&type=template&id=2344de29&scoped=true"
import script from "./tabbar3.8.vue?vue&type=script&lang=js"
export * from "./tabbar3.8.vue?vue&type=script&lang=js"
import style0 from "./tabbar3.8.vue?vue&type=style&index=0&id=2344de29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2344de29",
  null
  
)

export default component.exports